import type { UseDraggableArguments } from '@dnd-kit/core';

import type { DNDItem } from './types';

/**
 * Converts a DNDItem into a dnd-kit UseDraggableArguments object to
 * be used with the useDraggable hook.
 *
 * Example:
 *
 *   const drag = useDraggable({
 *       ...getDragItem(dndItem),
 *       disabled: readOnly,
 *   });
 *
 */
export function getDragItem(input: DNDItem) {
    return {
        id: `${input.type}/${input.id}`,
        data: input,
    } satisfies Pick<UseDraggableArguments, 'id' | 'data'>;
}
